// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__1gpGZ form_form__a6yyo","linksForm":"LoginForm_linksForm__3WehA","link":"LoginForm_link__2QSbo LinkNative_link__hGO0Z"};